import React from 'react'
import Card from '../card'
import ReactDOM from 'react-dom';

/**
 * @param table
 */
class LastTrick extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            hovered: undefined,
        }
    }

    render()
    {
        const trick = this.props.table.get("lastTrick")
        const player = id => this.props.table.get("players").find(p => p.get("id") === id)

        if (trick) {
            const cards = trick.get("cards").map((c, idx) => {

                const targetPlayer = player(trick.get("playerIds").get(idx))

                return (
                    <Card
                        key={ c + "-" + idx }
                        cardId={ c }
                        style={{
                            width: 120 * 0.6483516484,
                            height: 120,
                            borderRadius: 0.06 * 120
                        }}
                        onMouseEnter={ () => this.setState({ hovered: trick.get("playerIds").get(idx) }) }
                        onMouseLeave={ () => this.setState({ hovered: null }) }
                        className={ targetPlayer ? ("player-" + targetPlayer.get("color").toLowerCase()) : "" }
                    />
                )
            })

            const hoveredCardPlayer = this.state.hovered ? player(this.state.hovered) : null
    
            const infoText = hoveredCardPlayer
                ? Messages("table.last-trick.played", hoveredCardPlayer.get("name"))
                : undefined
    
            return (
                <div className="last-trick">
                    <div className="cards">
                        { cards }
                    </div>
                    <div className="card-info">
                        { infoText }
                    </div>
                </div>
            )
        } else {
            return null
        }
        
    }

}

export default LastTrick
export { LastTrick }